import alt from 'alt'
import { createActions } from 'alt-utils/lib/decorators'
import { SEOSettingsSource } from 'sources'

@createActions(alt)
export default class SEOSettingsActions {
  constructor() {
    this.generateActions(
      'setFetching',
      'setSettings',
      'updateSettings',
      'setErrored'
    )
  }

  fetch() {
    setTimeout(() => {
      this.setFetching(true)

      SEOSettingsSource.fetch()
        .then(resp => {
          this.setSettings(resp)
        })
        .catch(error => {
          console.log(error)
          this.setErrored(true)
        })
    }, 0)
  }

  update(settings, callback) {
    this.setFetching(true)
    return SEOSettingsSource.update(settings)
      .then(resp => {
        this.updateSettings(resp)
      })
      .catch(error => {
        console.log(error)
        this.setErrored(true)
      })
      .finally(() => {
        callback && callback()
      })
  }
}


// WEBPACK FOOTER //
// ./app/actions/SEOSettingsActions.js